import Pool from './utils/object/Stack.js';
export default Pool;